// Who may still use the retired Classic link submission page:
// superadmins, users at the companies listed below, and specific emails.
const linkSubmissionAllowedCompanies = ['awin']

const linkSubmissionAllowedEmails = [
  'steven.brown+awin@moonpullpartners.com',
  'lorean.brazil+awin@moonpullpartners.com',
]

interface LinkSubmissionUser {
  email?: string
  company?: { name?: string; isSuperAdmin?: boolean }
}

export function canUseRetiredLinkSubmission(user?: LinkSubmissionUser | null): boolean {
  if (!user) return false
  if (user.company?.isSuperAdmin) return true
  const companyName = user.company?.name?.toLowerCase()
  if (companyName && linkSubmissionAllowedCompanies.includes(companyName)) return true
  const email = user.email?.toLowerCase()
  return !!email && linkSubmissionAllowedEmails.includes(email)
}
